module.exports = __webpack_public_path__ + "img/banner-experience.8be227f8.png";